import React from 'react';
import PropTypes from 'prop-types';
import { SideNav, SideNavItems } from 'carbon-components-react';
import UserContext from 'contexts/UserConext';
export const LeftHandSideRail: React.FC<Props> = (props: any) => {
  const { sideRailButtons } = props;
  return (
    <UserContext.Consumer>
      {() => {
        return (
          <SideNav
            isFixedNav
            expanded={true}
            isChildOfHeader={true}
            aria-label="Side navigation"
            className="leftHandSideRail"
            data-testid="LeftHandSideRail"
          >
            <SideNavItems>{sideRailButtons}</SideNavItems>
          </SideNav>
        );
      }}
    </UserContext.Consumer>
  );
};

const propTypes = {
  sideRailButtons: PropTypes.element
};

type Props = PropTypes.InferProps<typeof propTypes>;

LeftHandSideRail.propTypes = propTypes;

export default LeftHandSideRail;
